import axios from 'axios';
import axiosRetry from 'axios-retry';

const axiosConfig = {
    credentials: 'include',
    timeout: 4000,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
};
const retryDelay = () => 1000;

const axiosInstance = axios.create({ ...axiosConfig });

// There is some weird issue with the types after updating axios to version 1.x
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
axiosRetry(axiosInstance, { retries: 2, retryDelay });

export default axiosInstance;
